"use client"

import { type Tone, cn, toneClass } from "../../lib/utils"
import * as LabelPrimitive from "@radix-ui/react-label"
import * as React from "react"

function Label({
  className,
  tone,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root> & { tone?: Tone }) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        "flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        toneClass(tone),
        className,
      )}
      {...props}
    />
  )
}

export { Label }
